import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api } from "@/lib/api";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Table, TableHeader, TableBody, TableHead, TableRow, TableCell } from "@/components/ui/table";

const STATUS_OPTIONS = ["baru", "diproses", "dikirim", "selesai", "batal"];

const STATUS_STYLE = {
  baru: "bg-honey-light text-honey-dark",
  diproses: "bg-blue-100 text-blue-700",
  dikirim: "bg-purple-100 text-purple-700",
  selesai: "bg-green-100 text-green-700",
  batal: "bg-red-100 text-red-700",
};

export const AdminOrders = () => {
  const qc = useQueryClient();
  const { data: orders = [], isLoading } = useQuery({
    queryKey: ["orders"],
    queryFn: async () => (await api.get("/orders")).data,
  });

  const updateStatus = async (id, status) => {
    try {
      await api.put(`/orders/${id}`, { status });
      qc.invalidateQueries({ queryKey: ["orders"] });
      toast.success("Status pesanan diperbarui.");
    } catch (err) {
      toast.error("Gagal memperbarui status.");
    }
  };

  return (
    <div>
      <h1 className="font-display text-3xl text-ink tracking-tight mb-1">Pesanan</h1>
      <p className="text-stone2 text-sm mb-6">Pesanan yang masuk lewat form pemesanan di halaman utama.</p>

      <div className="rounded-2xl bg-white border border-border/60 overflow-x-auto">
        {isLoading ? (
          <div className="p-10 text-center text-stone2">Memuat...</div>
        ) : orders.length === 0 ? (
          <div className="p-10 text-center text-stone2">Belum ada pesanan masuk.</div>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Tanggal</TableHead>
                <TableHead>Nama</TableHead>
                <TableHead>No. HP</TableHead>
                <TableHead>Produk</TableHead>
                <TableHead>Jumlah</TableHead>
                <TableHead>Catatan</TableHead>
                <TableHead>Status</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {orders.map((o) => (
                <TableRow key={o.id} data-testid={`order-row-${o.id}`}>
                  <TableCell className="whitespace-nowrap">
                    {new Date(o.created_at).toLocaleDateString("id-ID", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })}
                  </TableCell>
                  <TableCell>{o.name}</TableCell>
                  <TableCell>{o.phone}</TableCell>
                  <TableCell>{o.product}</TableCell>
                  <TableCell>{o.quantity}</TableCell>
                  <TableCell className="max-w-xs truncate">{o.notes || "-"}</TableCell>
                  <TableCell>
                    <Select value={o.status} onValueChange={(v) => updateStatus(o.id, v)}>
                      <SelectTrigger
                        data-testid={`order-status-${o.id}`}
                        className={`h-8 w-32 border-0 text-xs font-semibold ${STATUS_STYLE[o.status] || ""}`}
                      >
                        <SelectValue />
                      </SelectTrigger>
                      <SelectContent>
                        {STATUS_OPTIONS.map((s) => (
                          <SelectItem key={s} value={s}>
                            {s}
                          </SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </div>
    </div>
  );
};
